import styled from 'styled-components';

export const CodeWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: #2d2d2d;
  padding: 48px;
  font-size: 18px;
  overflow: scroll;
`;
